import axios from 'axios';

// Create an instance of axios
const api = axios.create({
    baseURL: window.APP_CONFIG?.API_URL, // Base API URL
});

// Add a request interceptor to inject the token
api.interceptors.request.use(
    (config) => {
        const token = sessionStorage.getItem('token'); // Get token from localStorage
        if (token) {
            config.headers.Authorization = `Bearer ${token}`; // Attach token to Authorization header
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default api;